export default "__VITE_ASSET__sIk1cwSf__"